export enum CompanyObjectiveTitleRejectionReason {
  LooksLikeKeyResult = 'looks_like_key_result',
  LooksLikeOutput = 'looks_like_output',
  ContainsTimebox = 'contains_timebox',
  OutOfTeamControl = 'out_of_team_control',
  NotAStateChange = 'not_a_state_change',
  NotMemorable = 'not_memorable',
  TooVague = 'too_vague',
}

export const COMPANY_OBJECTIVE_TITLE_REJECTION_REASON_LABELS: Record<CompanyObjectiveTitleRejectionReason, string> = {
  [CompanyObjectiveTitleRejectionReason.LooksLikeKeyResult]: 'Esto parece un Key Result',
  [CompanyObjectiveTitleRejectionReason.LooksLikeOutput]: 'Esto parece un entregable, no un objetivo',
  [CompanyObjectiveTitleRejectionReason.ContainsTimebox]: 'El título no debe incluir fechas ni trimestres',
  [CompanyObjectiveTitleRejectionReason.OutOfTeamControl]: 'El equipo no puede mover esta palanca',
  [CompanyObjectiveTitleRejectionReason.NotAStateChange]: 'No describe el destino que queremos alcanzar',
  [CompanyObjectiveTitleRejectionReason.NotMemorable]: 'No es fácil de recordar ni de repetir',
  [CompanyObjectiveTitleRejectionReason.TooVague]: 'El objetivo es demasiado genérico',
};
